/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar } from "@aws-amplify/ui-react";
import { Box, Button, Flex, Paper, Stack, Text, Title } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import {
  fetchUserAttributes,
  FetchUserAttributesOutput
} from "aws-amplify/auth";
import { getUrl } from "aws-amplify/storage";
import { useEffect, useState } from "react";
import {
  ModelSortDirection,
  Patient,
  PatientsByLIDAndUpdatedAtQuery,
  PatientsByLIDAndUpdatedAtQueryVariables
} from "../../API";
import { patientsByLIDAndUpdatedAtShallow } from "../../graphql/patientsByLIDAndUpdatedAtShallow";
import { sortByUpdatedAt } from "../../utils/utils";
import SkeletonPatient from "./SkeletonPatient";
import { useNavigate } from "react-router-dom";
const client = generateClient();
const queryLimit = 1000;

const RecentPatientComponent = () => {
  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState<any>();
  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    try {
      const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();
      if (userInfo["custom:location"] === undefined) {
        setLoading(false);
        return;
      }

      const patientData = await fetchPatientList(userInfo);
      console.log({ patientData });

      const patientsResult = patientData.data?.patientsByLIDAndUpdatedAt;
      if (!patientsResult) {
        setLoading(false);
        return;
      }

      const patientList = await fetchPatientImages(patientData);

      const filteredPatientList = patientList.filter(
        (patient): patient is Patient => patient !== undefined
      );
      const resultPatient = filteredPatientList.sort(sortByUpdatedAt);
      if (resultPatient.length > 5) {
        resultPatient.length = 5;
      }
      console.log(resultPatient);

      setPatients(resultPatient);
    } catch (err) {
      console.warn(err);
    }
    setLoading(false);
  };
  const fetchPatientImages = async (patientData: any) => {
    return await Promise.all(
      patientData.data.patientsByLIDAndUpdatedAt!.items.map(
        async (patient: any) => {
          try {
            patient!.s3Image = (
              await getUrl({
                path: `public/${patient!.image}`,
                options: { validateObjectExistence: true }
              })
            ).url.toString();
            // patient.s3Image = image;
          } catch (err) {
            console.warn("error getting patient image", patient!.name, err);
            patient!.s3Image = (
              await getUrl({
                path: `public/pet-image-placeholder.png`,
                options: { validateObjectExistence: true }
              })
            ).url.toString();
            // patient.s3Image = s3Image;
          }
          return patient;
        }
      )
    );
  };
  const fetchPatientList = async (userInfo: any) => {
    const patientQueryInput: PatientsByLIDAndUpdatedAtQueryVariables = {
      lID: userInfo["custom:location"],
      limit: queryLimit,
      sortDirection: ModelSortDirection.DESC,
      filter: {
        _deleted: { ne: true }
      }
    };
    const patientData = await client.graphql<
      GraphQLQuery<PatientsByLIDAndUpdatedAtQuery>
    >({
      query: patientsByLIDAndUpdatedAtShallow,
      variables: patientQueryInput
    });
    return patientData;
  };
  return (
    <Paper withBorder shadow="sm" px={30} py={28}>
      <Title size={"20"} mb={36} c={"#2D2D2D"}>
        Recent Patient Visits{" "}
      </Title>
      {loading && (
        <Stack>
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
        </Stack>
      )}
      {!loading && (
        <Stack>
          {patients?.map((patient: any) => (
            <Flex flex={1} key={patient.id}>
              <Avatar width={36} height={36} src={patient.s3Image} />
              <Flex ml={10} direction={"column"}>
                <Text
                  fw={"600"}
                  fz={14}
                  c={"#003554"}
                  lh={1}
                  td={"underline"}
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(`/cases/${patient.id}`, { state: patient })
                  }
                >
                  {patient.name}
                </Text>
                {patient?.client && (
                  <Text
                    size={"12px"}
                    fw={600}
                    fs={"italic"}
                    c={"#666666"}
                    mt={8}
                    lh={1}
                  >
                    {`Client: ${patient.client}`}
                  </Text>
                )}
              </Flex>
            </Flex>
          ))}
          <Button
            radius={"lg"}
            w={200}
            p={0}
            justify="flex-start"
            onClick={() => {
              navigate("/patients", { state: { addPatient: true } });
            }}
          >
            <Box px={8}>
              <IconPlus />
            </Box>
            <Text lh={1} fz={14} fw={600}>
              Create New Patient
            </Text>
          </Button>
        </Stack>
      )}
    </Paper>
  );
};
export default RecentPatientComponent;
